/* eslint-disable sort-keys */
import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { createLocale } from 'locales';

import Table from 'components-new/table/table';
import TextButton from 'components-new/text-button/text-button';
import Typography from 'components-new/typography/typography';
import FloatingActionBar from 'components-new/floating-action-bar/floating-action-bar';
import type { IconTypes } from 'components-new/icon/icon.types';

import OrganisationSettingsPageContainer from 'pages/organization/OrganisationSettingsPage/components/organisation-settings-page-container';

import useOrganisationSettingsIntegrationSelect from 'state/remote/remote-organization/organisation-settings/use-organisation-settings-integration-select';

import organisationSettingsRoutes, {
  IntegrationSettingsBaseRoute,
} from '../organisation-settings-routes';

const localize = createLocale('organisationIntegrationSettingsLocales');

const SelectJobsPage: React.FC = () => {
  const navigate = useNavigate();

  const { crumbs, table, updateSelectedJobs } =
    useOrganisationSettingsIntegrationSelect();

  const onCreateJobsClicked = useCallback(() => {
    updateSelectedJobs();
    navigate(
      IntegrationSettingsBaseRoute + organisationSettingsRoutes.createJobs.path,
    );
  }, [navigate, updateSelectedJobs]);

  return (
    <OrganisationSettingsPageContainer
      title={localize('foundJobs', { count: table.data.length })}
      selectedRoute={{ groupName: 'organisation', name: 'integrations' }}
      crumbs={crumbs}
      containerSize="full"
    >
      <Table
        data={table.data}
        fields={table.fields}
        totalPages={table.totalPages}
        hasNextPage={table.totalPages > table.page}
        hasPreviousPage={table.page > 1}
        currentPage={table.page}
        onPageChange={(p) => table.setPage(p)}
        pageSizeOptions={[10, 20, 50, 100]}
        currentPageSize={table.currentPageSize}
        onNumberOfItemsPerPageChange={(n) =>
          table.onNumberOfItemsPerPageChange(n)
        }
        onSelectedItemsChange={table.onSelectedItemsChange}
      />

      <FloatingActionBar visible={!!table.selectedJobIds.length}>
        <Typography
          variant="ui-button-lg"
          as="span"
          className="flex items-center space-x-2 text-gray-600"
        >
          <span className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-1">
            {table.selectedJobIds.length}
          </span>
          {localize('selected')}
        </Typography>
        <TextButton
          variant="primary"
          label={localize('createJobs')}
          leftIconProps={{ icon: 'folder-add' as IconTypes }}
          onClick={onCreateJobsClicked}
        />
      </FloatingActionBar>
    </OrganisationSettingsPageContainer>
  );
};

export default SelectJobsPage;
